import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ActionBarProps {
    onClear?: () => void;
    onConfirm?: () => void;
}

const ActionBar = ({ onClear, onConfirm }: ActionBarProps) => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            justifyContent="flex-end"
            sx={{ marginRight: 2, marginBottom: 1 }}
        >
            {onClear && (
                <Button variant="text" onClick={() => onClear && onClear()}>
                    {t("button.clear")}
                </Button>
            )}
            {onConfirm && (
                <Button variant="text" onClick={() => onConfirm && onConfirm()}>
                    Ok
                </Button>
            )}
        </Box>
    );
};

export default ActionBar;
